import React from 'react';
import styles from './Hero.module.css';
import { Logo } from '../Logo';
import { Waves } from '../Waves';
import { CTAButton } from '../CTAButton';
import { PhoneMockup } from '../PhoneMockup';
import { LINKS } from '../../config/links';

export function Hero() {
  return (
    <section className={styles.hero}>
      <div className={`${styles.reveal} ${styles.d0}`}>
        <Logo />
      </div>

      <h1 className={`${styles.title} ${styles.reveal} ${styles.d1}`}>
        VOICE&nbsp;<span className={styles.accent}>CUT</span>
      </h1>

      <p className={`${styles.tagline} ${styles.reveal} ${styles.d2}`}>
        Удаление вокала из аудио, видео и ссылок YouTube/Rutube — чистые минусы и рингтоны для мобил
      </p>

      <div className={`${styles.reveal} ${styles.d2}`}>
        <Waves />
      </div>

      <div className={`${styles.reveal} ${styles.d3}`}>
        <PhoneMockup src={`${process.env.PUBLIC_URL}/phone-telegram.jpg`} alt="Чат с ботом Voice Cut в Telegram" />
      </div>

      <div className={`${styles.reveal} ${styles.d3}`}>
        <CTAButton href={LINKS.bot}>Наш телеграм бот</CTAButton>
      </div>

      <p className={`${styles.bonus} ${styles.reveal} ${styles.d4}`}>
        🎁 Новым пользователям — бесплатное удаление вокала, рингтоны и 3 дня пробной подписки
      </p>
    </section>
  );
}
